// extracted by mini-css-extract-plugin
module.exports = {"promoContainer":"PromoPill_promoContainer__Zy9Kq","promo":"PromoPill_promo__18W9P","myPurchase":"PromoPill_myPurchase__ETaZj"};